<div class="app-content content" *ngIf="response">
    <div class="content-wrapper">
      <div class="content-header row mb-1">
        <app-breadcrumb class="col-12" [breadcrumb]="breadcrumb"></app-breadcrumb>
      </div>
      <div class="content-body">
        <section id="offers-active">
          <div class="col-md-12">
            <div class="card">
              <div class="table-responsive card-body">
                <table *ngIf="response != null || response?.length > 0"
                class="table table-column table-hover">
                  <thead class="thead bg-blue1">
                    <tr>
                      <th scope="col">
                        <h5 class="text-bold-600">N°</h5></th>                      
                      <th scope="col">
                        <h5 class="text-bold-600">Usuario</h5></th>
                      <th scope="col">
                        <h5 class="text-bold-600">Nombre</h5></th>
                    </tr>
                  </thead>
                  <tbody *ngFor="let admin of response; let i = index;">
                    <tr class="ng-star-inserted">
                        <th scope="row">{{ i+1 }}</th>
                        <th scope="row">{{ admin.usuario }}</th>
                        <td scope="row">{{ admin.nombre }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row">
              <br><br><br>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
  